import { awaitSelector, watchAwaitSelector, addToCartStandalone } from './functions'

HTMLDocument.prototype.ready = function () {
  // Document load/ready promise, calls 'ready' method when completed
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  watchAwaitSelector(function () {
    const upsellVariant = document.getElementById('upsell-variant')
    const upsellButton = document.getElementById('upsell-add')

    upsellButton.addEventListener('click', function (event) {
      // For some reason it was being redirected to the cart page
      event.preventDefault()
      const selected = upsellVariant.options[upsellVariant.selectedIndex]
      // console.log(addToCartStandalone(selected.dataset.variant, 1));

      const item = addToCartStandalone(selected.dataset.variant, 1)
    })
  }, '#upsell-add')

  // let template = `<div class="CartItem">
  //     <div class="CartItem__ImageWrapper AspectRatio">
  //       <div class="AspectRatio" style="--aspect-ratio: ${item.featured_image.aspect_ratio}">
  //         <img class="CartItem__Image" src="${item.featured_image.url}" alt="${item.featured_image.alt}">
  //       </div>
  //     </div>

  //     <div class="CartItem__Info">
  //       <h2 class="CartItem__Title Heading">
  //         <a href="${item.url}">${item.product_title}</a>
  //       </h2>

  //       <div class="CartItem__Meta Heading Text--subdued">
  //           <p class="CartItem__Variant">${item.variant_title}</p>

  //         <div class="CartItem__PriceList">
  //           {%- if line_item.original_price != line_item.final_price -%}
  //             <span class="CartItem__Price Price Price--highlight" data-money-convertible>{{ line_item.final_price | money_without_trailing_zeros }}</span>
  //             <span class="CartItem__OriginalPrice Price Price--compareAt" data-money-convertible>{{ line_item.original_price | money_without_trailing_zeros }}</span>
  //           {%- else -%}
  //             <span class="CartItem__Price Price" data-money-convertible>{{ line_item.final_price | money_without_trailing_zeros }}</span>
  //           {%- endif -%}

  //           {%- if line_item.line_level_discount_allocations != blank -%}
  //             <ul class="CartItem__DiscountList">
  //               {%- for discount_allocation in line_item.line_level_discount_allocations -%}
  //                 <li class="CartItem__Discount">
  //                   {%- render 'icon' with 'sale' -%}{{ discount_allocation.discount_application.title }}: -{{ discount_allocation.amount | money }}
  //                 </li>
  //               {%- endfor -%}
  //             </ul>
  //           {%- endif -%}
  //         </div>
  //       </div>

  //       {%- capture item_actions -%}
  //         <div class="CartItem__Actions Heading Text--subdued" style="text-align: center">
  //           <div class="CartItem__QuantitySelector">
  //             <div class="QuantitySelector">
  //               {%- assign quantity_minus_one = line_item.quantity | minus: 1 -%}

  //               <a class="QuantitySelector__Button Link Link--primary" title="{{ 'cart.items.set_quantity' | t: new_quantity: quantity_minus_one }}" href="{{ routes.cart_change_url }}?quantity={{ quantity_minus_one }}&id={{ line_item.key }}" data-quantity="{{ quantity_minus_one }}" data-line-id="{{ line_item.key }}" data-action="update-item-quantity">
  //                 {%- render 'icon' with 'minus' -%}
  //               </a>

  //               <input type="text" name="updates[]" id="updates_{{ line_item.key }}" class="QuantitySelector__CurrentQuantity" pattern="[0-9]*" data-line-id="{{ line_item.key }}" value="{{ line_item.quantity }}">

  //               {%- assign quantity_plus_one = line_item.quantity | plus: 1 -%}

  //               <a class="QuantitySelector__Button Link Link--primary" title="{{ 'cart.items.set_quantity' | t: new_quantity: quantity_plus_one }}" href="{{ routes.cart_change_url }}?quantity={{ quantity_plus_one }}&id={{ line_item.key }}" data-quantity="{{ quantity_plus_one }}" data-line-id="{{ line_item.key }}" data-action="update-item-quantity">
  //                 {%- render 'icon' with 'plus' -%}
  //               </a>
  //             </div>
  //           </div>

  //           <a href="{{ routes.cart_change_url }}?quantity=0&id={{ line_item.key }}" class="CartItem__Remove Link Link--underline Link--underlineShort" data-quantity="0" data-line-id="{{ line_item.key }}" data-action="remove-item">{{ 'cart.items.remove' | t }}</a>
  //         </div>
  //       {%- endcapture -%}

  //       {{ item_actions }}
  //     </div>

  //     {%- unless for_drawer -%}
  //       {{ item_actions }}

  //       <div class="CartItem__LinePriceList Heading Text--subdued" style="text-align: right">
  //         {%- if line_item.original_line_price != line_item.final_line_price -%}
  //           <span class="CartItem__Price Price Price--highlight" data-money-convertible>{{ line_item.final_line_price | money_without_trailing_zeros }}</span>
  //           <span class="CartItem__Price Price Price--compareAt" data-money-convertible>{{ line_item.original_line_price | money_without_trailing_zeros }}</span>
  //         {%- else -%}
  //           <span class="CartItem__Price Price" data-money-convertible>{{ line_item.final_line_price | money_without_trailing_zeros }}</span>
  //         {%- endif -%}
  //       </div>
  //     {%- endunless -%}
  //   </div>`;
})
